import React from 'react'
import logo from '../../assets/logo.png'
import './Header.css'
import Bars from '../../assets/bars.png'
import { useState } from 'react'
import { Link } from 'react-scroll'
const Header = () => {
  const mobile=window.innerWidth=768 ? true :false;
  const [menueOpened,setMenueOpened]=useState(false);
  return (
    <div className='main-header'>
      <div className="logo">
        <img className='logo-img' src={logo} alt="" srcset="" />
      </div>
      {menueOpened===false &&mobile===true?(
       <div style={{backgroundColor:"var(--appColor)",padding:"0.5rem",borderRadius:"5px",justifyContent:"center",alignItems:"center",display:"flex"}} className='bar' onClick={()=>setMenueOpened(true)}>
        <img style={{width:"1.5rem",height:"1.5rem"}} src={Bars} alt="" />
       </div>):(
      <div className="list">
        <ul className='header-menue'>
            <li><Link onClick={()=>setMenueOpened(false)} to='Home' span={true} smooth={true}>HOME</Link></li>
            <li><Link onClick={()=>setMenueOpened(false)} to='Programs' span={true} smooth={true}>PROGRAMS</Link></li>
            <li><Link onClick={()=>setMenueOpened(false)} to='Why-Us' span={true} smooth={true}>WHY US</Link></li>
            <li><Link onClick={()=>setMenueOpened(false)} to='Plans' span={true} smooth={true}>PLANS</Link></li>
            <li><Link onClick={()=>setMenueOpened(false)} to='Testimonials' span={true} smooth={true}>TESTIMONIALS</Link></li>
        </ul>
      </div>
      )}
    </div>
  )
}

export default Header
